/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { updateProfile } from '../../config/updateProfile.config';

import axios from 'axios';
import { AppNavigatorService } from '@/AppNavigator';
import { Graphql } from '@common/graphql';
import { UPDATE_MY_PROFILE,REJECTED_DOC_APPLICATION_SUBMIT } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';

export interface IDocRejectUpdateProfileMethods extends IPluginMethodMap {
  getDocRejectUpdate(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface DocRejectUpdateProfileProps {}

export class DocRejectedUpdateProfileService implements IAgentPlugin {
  readonly methods: IDocRejectUpdateProfileMethods;

  constructor() {
    this.methods = {
      getDocRejectUpdate: this.getDocRejectUpdate.bind(this),
    };
  }

  _getRejectedDocument = (data: any) => {
    let _documents: any[] = [];
    console.log(`service args`, data);
    // workPermitConfig?.availableDocuments &&
    Object.entries(data).forEach((ele) => {
      if (
        data[ele[0]] &&
        Array.isArray(data[ele[0]]) &&
        data[ele[0]].length > 0
      ) {
        let _docs: any[] = [];
        console.log(`service args getDocuments #1`, data[ele[0]]);
        const ans = data[ele[0]];
        if (ans && Array.isArray(ans) && ans.length > 0) {
          ans.forEach((e) => {
            console.log('service args e', e);
            _docs.push({
              name:
                (e?.evidences &&
                  Array.isArray(e?.evidences) &&
                  e?.evidences[0]?.name) ||
                (e?.photo && Array.isArray(e?.photo) && e?.photo[0]?.name),
              type: e?.evidencetype,
              src:
                (e?.evidences &&
                  Array.isArray(e?.evidences) &&
                  e?.evidences[0]?.base64) ||
                (e?.photo && Array.isArray(e?.photo) && e?.photo[0]?.base64),
              fileType:
                (e?.evidences &&
                  Array.isArray(e?.evidences) &&
                  e?.evidences[0]?.type) ||
                (e?.photo && Array.isArray(e?.photo) && e?.photo[0]?.type),
            });
          });
        }
        console.log(
          `workPermitApp service getDocuments #2 doc`,
          _documents,
          _docs
        );
        _documents = [..._documents, ..._docs];
      }
    });
    console.log('service args documents', _documents);
    return _documents;
  };

  async getDocRejectUpdate(args: any) {
    console.log('data in mutation update rejected docprofile', args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    try {
      if (client) {
        console.log(client);
        if(args?.type==='CARICOM_BUSINESS_ORG'){
          const res = await client
          .mutation(
            REJECTED_DOC_APPLICATION_SUBMIT,

            {
              input: {
                documents: this._getRejectedDocument(args?.documents),
                applicationNo : args?.appno,
              },
            }
          )
          .toPromise();

          if (res?.data?.reSubmitApplicationDoc) {
            return {
              data: res?.data?.reSubmitApplicationDoc,
            };
          }
          console.log('qqq err caught');
          throw res?.data?.errors?.[0];
        
        }
        else{
        const res = await client
          .mutation(
            UPDATE_MY_PROFILE,

            {
              input: {
                documents: this._getRejectedDocument(args?.documents),
                submit: true,
              },
            }
          )
          .toPromise();

        if (res?.data?.setUpOrgProfile) {
          return {
            data: res?.data?.setUpOrgProfile,
          };
        }
        throw res?.data?.errors?.[0];
      }
      }
    } catch (err: any) {
      throw err;
    }
    return { data: updateProfile };
  }
}
